import { useState, useEffect } from 'react';
import { publicEventService } from '../services/publicEventService';

// Carrega os eventos aprovados de uma categoria (página /categoria/:slug).
export function useCategoryEvents(categorySlug) {
  const [events,  setEvents]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);
        const data = await publicEventService.getEventsByCategory(categorySlug);
        if (!cancelled) setEvents(data);
      } catch (err) {
        if (!cancelled) {
          console.error('useCategoryEvents:', err);
          setError('Não foi possível carregar os eventos desta categoria.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    if (!categorySlug) {
      setEvents([]);
      setLoading(false);
      return;
    }

    load();
    return () => { cancelled = true; };
  }, [categorySlug]);

  return { events, loading, error };
}
